import React from 'react';
import { PrismicText } from 'components/Prismic';
import { Arrow } from 'components/Icons';
import { PrismicLink } from 'components/PrismicLink';
import { PrismicTitleFieldType, PrismicLinkFieldType, SliceContext } from '../types';
import './Feature.scss';

export type FeatureCTAProps = {
    ctaLabel: PrismicTitleFieldType;
    ctaLink: PrismicLinkFieldType;
    sliceContext: SliceContext;
};

const FeatureCTA = ({ ctaLabel, ctaLink, sliceContext }: FeatureCTAProps) => {
    if (!ctaLink || !ctaLabel) {
        return null;
    }
    return (
        <PrismicLink link={ctaLink} className="Feature-cta-link" slice={sliceContext}>
            <div className="Grid Grid--alignCenter">
                <p>
                    <PrismicText content={ctaLabel} />
                    <Arrow className="Feature-cta-arrow" />
                </p>
            </div>
        </PrismicLink>
    );
};

export default FeatureCTA;
